<template>
  <div class="LicenseGraf">
    <div class="LicenseGraf__graf">
      <span class="LicenseGraf__value" :style="width"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LicenseGraf',
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    width() {
      return {
        '--width': `${this.percentage}%`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@spectee/assets/scss/_forward.scss' as *;

.LicenseGraf {
  width: 100%;

  &__graf {
    display: flex;
    flex-grow: 1;
    height: $service-unit * 3;
    background-color: #a9acb0;
  }

  &__value {
    display: inline-block;
    width: var(--width);
    background-color: #b556dc;
  }
}
</style>
